import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Version } from '../../models/versions/version.model';
import { ApiVersionsService } from '../../services/versions/api/api-versions.service';
import { AlertsService } from '../../services/alerts.service';
import { ModalsService } from '../../services/modals.service';
import { VersionAddModalComponent } from './modals/version-add-modal/version-add-modal.component';
import { VersionEditModalComponent } from './modals/version-edit-modal/version-edit-modal.component';

@Component({
  templateUrl: 'versions.component.html',
  standalone: true,
  imports: [CommonModule, TooltipModule, VersionAddModalComponent, VersionEditModalComponent]
})
export class VersionsComponent implements OnInit {

  @ViewChild('addModal') addModal!: VersionAddModalComponent;
  @ViewChild('editModal') editModal!: VersionEditModalComponent;

  versions: Version[] = [];

  constructor(
    private apiVersionsService: ApiVersionsService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  ngOnInit(): void {
    this.refreshVersions();
  }

  onClickAdd(): void {
    this.addModal.show(() => this.refreshVersions());
  }

  onClickEdit(version: Version): void {
    this.editModal.show(version.versionId, version.apiVersion, version.minAppVersion, version.gameServerVersion, version.isActive, () => this.refreshVersions());
  }

  onClickDelete(version: Version): void {
    this.modalsService.showConfirmModal(() => {
      this.apiVersionsService.deleteVersion(version.versionId).then(
        () => {
          this.alertsService.displayAlertSuccess('Version deleted !');
          this.refreshVersions();
        }, error => {
          this.alertsService.displayAlertError('Error deleting version : ' + error);
        }
      );
    });
  }

  private refreshVersions(): void {
    this.apiVersionsService.getVersions().then(
      response => {
        this.versions = response.results;
      }, error => {
        this.alertsService.displayAlertError('Error loading versions : ' + error);
      }
    );
  }
}
